import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch, watchEffect, onBeforeUnmount } from "vue";
import { ElConfigProvider } from "element-plus";
import zh from "element-plus/es/locale/lang/zh-cn";
import en from "element-plus/es/locale/lang/en";
import { useStore } from "@/store/index";
// import useWebSocket from "@/hook/useWebSocket";

export default {
  __name: 'App',
  setup(__props) {
    const store = useStore();
    const locale = ref(null);
    watchEffect(() => {
      locale.value = store.language === "zh" ? zh : en;
    });
    // 生成一个唯一的标签页ID,保证每个标签页是唯一的
    const tabId = crypto.randomUUID();
    // 创建一个频道连接
    const bc = new BroadcastChannel("token-check");
    // 收到来自其他标签页的消息时
    bc.onmessage = e => {
      const data = e.data;
      if (data.type === "login" && data.tabId !== tabId) {
        console.log(e.data);
        store.clearInfo();
      }
    };
    watch(() => store.token, token => {
      if (!token) return;
      console.log(tabId);
      // 通知其他标签页信息
      bc.postMessage({
        type: "login",
        tabId
      });
      // 创建 WebSocket 连接
      // useWebSocket();
    }, {
      immediate: true
    });
    const zoom = window.innerWidth / 1920;
    document.body.style.zoom = zoom;
    // 页面关闭清理
    onBeforeUnmount(() => {
      bc.close();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: locale.value
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, {
          style: {
            "width": "100%"
          }
        })]),
        _: 1
      }, 8, ["locale"]);
    };
  }
};